import React from "react";
import PropTypes from "prop-types";
import * as classes from "./MenuLayout.module.css";
import { Link } from "gatsby";

const MenuLayout = ({ items, currentPage, finnishLanguage }) => {
  return (
    <div className={classes.wrapper}>
      {items
        .filter((item) => {
          return item.page.slug !== null;
        })
        .map((item) => (
          <Link
            key={item.page.id}
            to={
              item.page.slug
                ? finnishLanguage
                  ? `/fi/${item.page.slug}`
                  : `/${item.page.slug}`
                : "/"
            }
            className={`${classes.menuLink} ${
              currentPage === item.page.slug ? classes.currentPage : ""
            }`}
          >
            {item.title}
          </Link>
        ))}
    </div>
  );
};

MenuLayout.propTypes = {
  items: PropTypes.array.isRequired,
  currentPage: PropTypes.string,
  finnishLanguage: PropTypes.bool
};

export default MenuLayout;
